export default __webpack_public_path__ + "static/1.1_DE-b5ee58d7219e0513898c8af54d947ebb.png";